/** Convert linear grayscale heights to tangent-space normals, wrapping at tile edges. */
export function heightToNormalPixels(
  heights: Uint8ClampedArray,
  width: number,
  height: number,
  strength = 2,
): Uint8ClampedArray {
  const normals = new Uint8ClampedArray(heights.length);
  const sample = (x: number, y: number): number =>
    heights[(((y + height) % height) * width + ((x + width) % width)) * 4] / 255;
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const nx = (sample(x - 1, y) - sample(x + 1, y)) * strength;
      const ny = (sample(x, y - 1) - sample(x, y + 1)) * strength;
      const length = Math.hypot(nx, ny, 1);
      const i = (y * width + x) * 4;
      normals[i] = (nx / length * 0.5 + 0.5) * 255;
      normals[i + 1] = (ny / length * 0.5 + 0.5) * 255;
      normals[i + 2] = (1 / length * 0.5 + 0.5) * 255;
      normals[i + 3] = 255;
    }
  }
  return normals;
}
